<template>
  <div class="row mb-3">
    <div class="col-12 form-group" v-if="isAdmin">
      <label for="notes">Notes</label>
      <textarea class="form-control" id="notes" v-model="userInfo.notes"></textarea>
    </div>
    <div class="col-12 row flex-md-nowrap no-gutters pr-md-4" v-if="userRole">
       <div class="col-12 col-md-auto form-group no-gutters">
        <label for="role">Role</label>
         <select class="form-control" id="role" required :disabled="(userRole !== 'Admin' && userRole !== 'SuperAdmin')">
          <option v-if="(userRole === 'Admin' || userRole === 'SuperAdmin')" value="Member" >Member</option>
          <option value="Volunteer">Volunteers</option>
        </select>
      </div>
    </div>

    <div class="col-12 col-md-6 row flex-md-nowrap no-gutters pr-md-4" v-if="isAdmin">
      <div class="col-12 col-md form-group no-gutters pr-md-4" v-if="(userRole === 'Admin' || userRole === 'SuperAdmin')">
        <label for="memberNumber">Member Number</label>
        <input type="text" class="form-control" id="memberNumber" :class="['form-control', errorStatus === 'member_number' ? 'is-invalid' : '']">
        <div class="invalid-tooltip">{{ errorStatus === 'member_number' ? 'Please include the another member number.' : '' }}</div>
      </div>
      <div class="col-12 col-md-auto form-group no-gutters">
        <label for="title">Title</label>
        <select class="form-control" id="title" required>
          <option disabled></option>
          <option value="Mr">Mr</option>
          <option value="Ms">Ms</option>
          <option value="Miss">Miss</option>
          <option value="Mrs">Mrs</option>
          <option value="Dr">Dr</option>
        </select>
        <div class="invalid-tooltip">Please include your title.</div>
      </div>
    </div>

    <div class="col-md-6" v-if="isAdmin">
    </div>

    <div class="col-12 col-md-6 pr-xl-4 form-group">
      <label for="firstName">First Name</label>
      <input type="text" class="form-control" id="firstName" v-model="userInfo.firstName" maxlength="40" required>
      <div class="invalid-tooltip">Please include your First Name.</div>
    </div>
    <div class="col-12 col-md-6 pl-xl-4 form-group">
      <label for="lastName">Last Name</label>
      <input type="text" class="form-control" id="lastName" v-model="userInfo.lastName" maxlength="40" required>
      <div class="invalid-tooltip">Please include your Last Name.</div>
    </div>

    <VueSlideToggle v-if="!isAdmin" :open="nameMatches" tag="div" :duration="500" class="col-12 px-lg-3">
      <div v-if="matchingNames.length">
        <p>Do you already have an account? If you are one of the following members, please log in with your existing account.</p>
        <table class="table table-striped">
          <thead>
            <tr>
              <td>First Name</td>
              <td>Last Name</td>
              <td>Member Number</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member) in matchingNames" :key="member.id" @click="getEmailAndRedirect(member)" class="clickable-row">
              <td>{{ member.first_name }}</td>
              <td>{{ member.last_name }}</td>
              <td>{{ member.member_number }}</td>
            </tr>
          </tbody>
        </table>
        <button type="button" class="btn btn-primary mb-3" @click="newMemberToggle">I am not listed above, I wish to register a new account</button>
      </div>
      <div v-else>
        <button type="button" class="btn btn-primary mb-3" @click="newMemberToggle">I wish to proceed with account registration</button>
      </div>
    </VueSlideToggle>

    <VueSlideToggle :open="isAdmin || newMember" tag="div" :duration="500" class="container">
      <div class="row">
        <div class="col-12 col-md-6 form-group no-gutters" :class="classAdminLeft" v-if="!isAdmin">
          <label for="title">Title</label>
          <select class="form-control" id="title" required>
            <option disabled></option>
            <option value="Mr">Mr</option>
            <option value="Ms">Ms</option>
            <option value="Miss">Miss</option>
            <option value="Mrs">Mrs</option>
            <option value="Dr">Dr</option>
          </select>
          <div class="invalid-tooltip">Please include your title.</div>
        </div>

        <div class="col-12 col-md-6 form-group" :class="classAdminRight">
          <label for="gender">Gender</label>
          <select class="form-control" id="gender" required>
            <option disabled></option>
            <option>Male</option>
            <option>Female</option>
            <option>Unspecified</option>
          </select>
          <div class="invalid-tooltip">Please include your Gender.</div>
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminLeft">
          <label for="dateOfBirth">Date of Birth</label>
          <input v-model="dateOfBirth" :max="today()" required :class="['form-control form-date', errorStatus === 'validation_error' ? 'is-invalid' : '']" id="dateOfBirth" type="date" :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" value="1988-01-01">
          <div class="invalid-tooltip">Please include your Date of Birth{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
        </div>
        <div class="col-12 col-md-6 form-group pr-xl-4">
          <label for="riderStatus">Rider Status</label>
          <select class="form-control" id="riderStatus">
            <option value="1">Maiden</option>
            <option value="2">Novice</option>
            <option value="3">Open</option>
          </select>
          <div class="invalid-tooltip">Please include the Rider Status.</div>
        </div>
        <div class="col-12 col-md-6 form-group pl-xl-4">
          <label for="boyStatus">Beginning of Year Status</label>
          <select class="form-control" id="boyStatus" >
            <option value="1">Maiden</option>
            <option value="2">Novice</option>
            <option value="3">Open</option>
          </select>
          <div class="invalid-tooltip">Please include the Rider Status.</div>
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminRight">
          <label for="email">Email Address</label>
          <input type="email" :class="['form-control', errorStatus === 'email' && errors ? 'is-invalid' : '']" id="email" maxlength="255" required v-model="userInfo.email">
          <div class="invalid-tooltip">{{ errorStatus === 'email' && errors ? errors : 'Please include your Email Address.' }}</div>

          <VueSlideToggle :open="emailFound" tag="div" :duration="500" v-if="isAdmin">
            <p class="small">This email address is already in use.</p>
          </VueSlideToggle>

          <VueSlideToggle :open="emailFound" tag="div" :duration="500" class="col-12 px-lg-3" v-else>
            <p class="small">This email address is already in use.
              <router-link tag="a" :to="{ name: 'Login', query: { email: userInfo.email } }" class="d-inline-block">Please log in to your account here</router-link>
            </p>
          </VueSlideToggle>
        </div>

        <div class="col-12 col-md-6 form-group" :class="classAdminLeft">
          <label for="phone">Phone Number</label>
          <input type="text" class="form-control" id="phone" v-model="userInfo.phone" maxlength="15" :required="!userInfo.mobile_phone">
          <div class="invalid-tooltip">Please include either a Phone or Mobile Number.</div>
        </div>

        <div class="col-12 col-md-6 form-group" :class="classAdminRight">
          <label for="mobile">Mobile Phone Number</label>
          <phone-input :class="[errorStatus === 'mobile_phone' ? 'is-invalid' : '']" id="mobile" v-model="userInfo.mobile_phone" :required="!userInfo.phone" />
          <div class="invalid-tooltip">Please include correct mobile phone number.</div>
          <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
          <test-phone-numbers />
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminLeft">
          <label for="carbon_copy_mobile">CC Mobile <small class="d-inline-block">(optional)</small></label>
          <phone-input :class="[errorStatus === 'carbon_copy_mobile' ? 'is-invalid' : '']" id="carbon_copy_mobile" v-model="userInfo.carbon_copy_mobile" />
          <div class="invalid-tooltip">Please enter correct CC mobile</div>
          <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
          <test-phone-numbers />
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminRight">
          <label for="address">Address Line 1</label>
          <input type="text" class="form-control" id="address" maxlength="80" required pattern=".{5,}">
          <div class="invalid-tooltip">Please include an address of at least 5 characters.</div>
          <small class="d-block">Must be at least 5 characters</small>
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminLeft">
          <label for="address2">Address Line 2 <small>(optional)</small></label>
          <input type="text" class="form-control" id="address2" maxlength="80">
          <div class="invalid-tooltip">Please include an address of at least 5 characters.</div>
        </div>

        <div class="col-12 col-md-6 form-group" :class="classAdminRight">
          <label for="suburb">Suburb</label>
          <input type="text" class="form-control" id="suburb" maxlength="40" required @input="findZone()" v-model="suburb">
          <div class="invalid-tooltip">Please include your Suburb.</div>
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminLeft">
          <label for="postcode">Postcode</label>
          <input type="text" class="form-control" id="postcode" maxlength="4" required pattern="\d{4}" @input="findZone()" v-model="postcode">
          <div class="invalid-tooltip">Please include a four-digit Postcode.</div>
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminRight">
          <label for="state">State</label>
          <select class="form-control" id="state" required>
            <option disabled></option>
            <option value="QLD">Queensland</option>
            <option value="NSW">New South Wales</option>
            <option value="VIC">Victoria</option>
            <option value="ACT">Australian Capital Territory</option>
            <option value="SA">South Australia</option>
            <option value="NT">Northern Territory</option>
            <option value="WA">Western Australia</option>
            <option value="TAS">Tasmania</option>
          </select>
          <div class="invalid-tooltip">Please include your State.</div>
        </div>
        <div class="col-12 col-md-6 form-group" :class="classAdminLeft">
          <label for="zone">Zone</label>
          <select class="form-control" id="zone" v-model="zone">
            <option :value="null">Unspecified</option>
            <option v-for="(zone, index) in $store.state.listZones.filter(zone => !zone.deleted_at)" :key="index" :value="zone.id">{{zone.code}}</option>
          </select>
          <div class="invalid-tooltip">Please include your Zone.</div>
          <div class="alert alert-warning alert-sm" v-if="zoneNotFound && !zoneNotSpecified">Unable to find matching Zone.</div>
          <div class="alert alert-warning alert-sm" v-else-if="zoneNotSpecified">{{ warningMessage }}</div>
          <div class="alert alert-success alert-sm" v-else-if="zoneFound">Found matching Zone.</div>
          <div class="alert alert-sm" v-else>&nbsp;</div>
        </div>

        <div class="col-12 col-md-6 form-group pl-xl-4">
          <label for="proofOfAge">Proof of Age</label>
          <div class="custom-file">
            <input type="file" :class="['custom-file-input font-weight-normal', { 'is-invalid': errorStatus === 'file' }]" id="proofOfAge" accept="image/*, application/pdf" @change="fileUpload">
            <label class="custom-file-label font-weight-normal" for="proofOfAge">{{file_name ? file_name : 'Choose file...'}}</label>
            <small>jpg, jpeg, png, tiff, gif, pdf file type required.</small>
            <br>
            <small>Your ID will be stored in a secure data storage</small>
            <button
              v-if="file_name"
              type="button"
              class="btn btn-link px-2 pl-md-0 px-xl-2 pr-md-1"
              @click="deleteAttachment"
            >
              <span class="sr-only">Delete File</span>
              <div class="btn-remove">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" aria-hidden="true" viewBox="0 0 17 17"><g fill="currentColor"><path d="M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"/><path d="M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"/><path d="M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"/></g></svg>
              </div>
            </button>
          </div>
        </div>

        <div class="col-12 col-md-6 pr-xl-4 form-group">
          <label for="password">Password</label>
          <input type="password" class="form-control" id="password" maxlength="30" required pattern="([A-Za-z0-9]){6,}" v-model="password.password">
          <div class="invalid-tooltip">Please include a Password between 6 and 30 characters, using only letters and numbers.</div>
          <small class="d-block">Must be between 6 and 30 characters, using only letters and numbers</small>
        </div>
        <div class="col-12 col-md-6 pb-md-5 pl-xl-4 form-group">
          <label for="confirmPassword">Confirm Password</label>
          <input type="password" class="form-control" id="confirmPassword" maxlength="30" required pattern="([A-Za-z0-9]){6,}" v-model="password.confirmPassword">
          <div class="invalid-tooltip">Please ensure your Password matches.</div>
        </div>
      </div>
    </VueSlideToggle>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import { VueSlideToggle } from 'vue-slide-toggle'
import PhoneInput from '@/components/FormFields/PhoneInput'
import TestPhoneNumbers from '@/components/TestPhoneNumbers'

export default {
  components: {
    TestPhoneNumbers,
    PhoneInput,
    VueSlideToggle
  },
  mixins: [HANDLESUBMIT, LEGACYBROWSERS],
  props: ['responseStatus', 'errorStatus', 'errors', 'isAdmin'],
  data() {
    return {
      zoneLocations: [],
      zoneNotFound: false,
      zoneFound: false,
      zoneNotSpecified: false,
      warningMessage: '',
      classAdminRight: this.isAdmin ? 'pr-xl-4' : 'pl-xl-4',
      classAdminLeft: this.isAdmin ? 'pl-xl-4' : 'pr-xl-4',
      password: {
        password: '',
        confirmPassword: ''
      },
      userInfo: {},
      ajaxingEmail: false,
      ajaxingName: false,
      emailFound: false,
      nameMatches: false,
      postcode: null,
      suburb: null,
      zone: null,
      cancelToken: axios.CancelToken.source(),
      matchingNames: [],
      newMember: this.isAdmin,
      userRole: localStorage.role,
      file_path: '',
      file_name: ''
    }
  },
  watch: {
    password: {
      handler(password) {
        this.$emit('input', password)
      },
      deep: true
    },
    computedUserInfo: {
      handler(userInfo, userInfoOld) {
        // Pass form data to parent
        this.$emit('userInfo', userInfo)
        // If name changed (not email)
        if (
          !this.matchingNames.length ||
          (
            (
              !userInfo.email &&
              !userInfoOld.email
            ) ||
            (
              userInfo.email &&
              userInfoOld.email &&
              userInfo.email === userInfoOld.email
            )
          )
        ) {
          this.closeNames()
          this.getNameMatch()
        } else if ( // If email changed
          userInfo.email &&
          (
            !userInfoOld.email ||
            userInfo.email !== userInfoOld.email
          )
        ) {
          this.getEmailMatch()
        }
      },
      deep: true
    },
    newMember(newMember) {
      this.$emit('newMember', newMember)
    }
  },
  computed: {
    // Necessary because Vue2 doesn't record the old value of a watched Object
    computedUserInfo() {
      return _.cloneDeep(this.userInfo)
    }
  },
  created() {
    this.getNameMatch = _.debounce(this.matchName, 300)
    this.getEmailMatch = _.debounce(this.checkEmail, 300)
    this.getZoneLocations()
  },
  methods: {
    findZone() {
      let coincidenceZones = []
      if (this.suburb && this.postcode) {
        coincidenceZones = this.zoneLocations.filter(
          ({ suburb, postcode }) => this.suburb.toUpperCase() === suburb && this.postcode === postcode) || {}
      } else if (this.suburb && !this.postcode) {
        this.warningMessage = 'Please refine the postcode to find zone matches.'
        coincidenceZones = this.zoneLocations.filter(
          ({ suburb }) => this.suburb.toUpperCase() === suburb) || {}
      } else if (this.postcode && !this.suburb) {
        this.warningMessage = 'Please refine the suburb to find zone matches.'
        coincidenceZones = this.zoneLocations.filter(
          ({ postcode }) => this.postcode === postcode) || {}
      }

      if (coincidenceZones.length === 1) {
        this.zoneNotFound = false
        this.zoneFound = true
        this.zone = coincidenceZones[0].zone_id
      } else if (coincidenceZones.length > 1) {
        this.zoneNotSpecified = true
        this.zoneFound = true
        this.zoneNotFound = false
      } else {
        this.zoneNotFound = true
        this.zoneFound = false
        this.zoneNotSpecified = false
      }
    },
    async getZoneLocations() {
      try {
        const { data: { data } } = await axios.get(`${this.$api}/zone-location/list`)
        this.zoneLocations = data || []
      } catch (error) {
        // Can't fetch zone locations error
      }
    },
    // Get difference between old and new values of an Object
    getDifference(userInfo, userInfoOld) {
      function changes(object, base) {
        return _.transform(object, (result, value, key) => {
          if (!_.isEqual(value, base[key])) {
            result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value
          }
        })
      }
      return changes(userInfo, userInfoOld)
    },
    checkEmail() {
      const value = this.userInfo.email
      if (this.ajaxingEmail !== false) {
        this.cancelToken.cancel('Aborting current request')
        this.ajaxingEmail = false
        this.emailFound = false
      }
      axios.post(`${this.$api}/auth/email-exists`, {
        email: value
      }).then((response) => {
        if (response.data.exists) {
          this.emailFound = true
        } else {
          this.emailFound = false
        }
      })
    },
    closeNames() {
      this.nameMatches = false
    },
    matchName() {
      if (!this.isAdmin) {
        if (this.ajaxingName !== false) {
          this.cancelToken.cancel('Aborting current request')
          this.ajaxingName = false
          this.nameMatches = false
        }

        if (
          this.userInfo.firstName &&
          this.userInfo.firstName.length > 0 &&
          this.userInfo.lastName &&
          this.userInfo.lastName.length > 0
        ) {
          axios.post(`${this.$api}/auth/match-user-by-name`, {
            first_name: this.userInfo.firstName,
            last_name: this.userInfo.lastName
          }).then((response) => {
            this.nameMatches = true
            if (response.data.matching.length) {
              this.matchingNames = response.data.matching
            } else {
              this.matchingNames = []
            }
          })
        }
      }
    },
    getEmailAndRedirect(member) {
      axios.post(`${this.$api}/auth/get-email-by-user-id`, {
        id: member.id,
        member_number: member.member_number
      }).then((response) => {
        if (response.data.email.length) {
          this.$router.push({ name: 'Login', query: { email: response.data.email } })
        }
      })
    },
    newMemberToggle() {
      this.newMember = true
      this.nameMatches = false
    },
    fileUpload(event) {
      this.file_name = ''
      const uploadedFile = event.target.files[0]
      this.file = uploadedFile
      if (uploadedFile) {
        this.file_name = uploadedFile.name
      }
    },
    deleteAttachment() {
      delete this.file
      this.file = undefined
      this.file_name = ''
    }
  }
}
</script>

<style>
  .clickable-row {
    cursor: pointer;
  }

  .clickable-row:hover {
    color: var(--primary);
  }
</style>



// WEBPACK FOOTER //
// src/views/Account/RegisterNew.vue